import { render, staticRenderFns } from "./TextImgView.vue?vue&type=template&id=47ea3c92&"
import script from "./TextImgView.vue?vue&type=script&lang=js&"
export * from "./TextImgView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports